module.exports = __webpack_public_path__ + "img/ruler-combined-solid.afba55cc.svg";